import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';

import { AjaxService } from '../../Services/Ajax/index.jsx';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error: error };
  }

  /**
   * Log the details of a caught error back to the server.
   */
  componentDidCatch(error, errorInfo) {
    var data = 'error=' + error.toString();
    data += '&errorStack=' + encodeURIComponent(errorInfo.componentStack);

    AjaxService.post('theme:react-error', data);
  }

  render() {
    if (this.state.error) {
      return (
        <Alert variant="danger">
          <Alert.Heading>Error:</Alert.Heading>
          <strong>A fatal error has occurred: </strong>
          <i>{this.state.error.toString()}</i>
          <br />
          Please reload the page to try again, or contact support for more
          assistance
        </Alert>
      );
    } else {
      return this.props.children;
    }
  }
}


export default ErrorBoundary;

